import type { CSSProperties } from 'react';

export interface RingsProps {
  style?: CSSProperties;
}

/** Ambient concentric rings backdrop — the Portal motif from the design. */
export function Rings({ style }: RingsProps) {
  return <div className="aw-rings" style={style} aria-hidden="true" />;
}
